import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { db, doc, getDoc, setDoc } from "../firebase";
import "./LoginPage.css";

const LoginPage = () => {
  const [accountNumber, setAccountNumber] = useState("");
  const [name, setName] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const navigate = useNavigate();

  // Login with an existing account number
// In LoginPage.js
const handleLogin = async () => {
  if (accountNumber.trim() === "") {
    setErrorMsg("Please enter your account number.");
    return;
  }
  console.log("Attempting login for account:", accountNumber);
  const userRef = doc(db, "users", accountNumber);
  const userSnap = await getDoc(userRef);
  if (userSnap.exists()) {
    console.log("User found:", userSnap.data());
    localStorage.setItem("accountNumber", accountNumber);
    localStorage.setItem("name", userSnap.data().name);
    console.log("Navigating to /home");
    navigate("/home"); // Changed here
  } else {
    setErrorMsg("Account not found! Please create an account first.");
    console.log("Account not found for:", accountNumber);
  }
};


  // Create a new account and log in
// In LoginPage.js, for account creation:
const handleCreateAccount = async () => {
  if (name.trim() === "") {
    setErrorMsg("Please enter your name.");
    return;
  }
  let newAccountNumber;
  let userExists = true;
  while (userExists) {
    newAccountNumber = Math.floor(100000 + Math.random() * 900000).toString();
    const userRef = doc(db, "users", newAccountNumber);
    const userSnap = await getDoc(userRef);
    userExists = userSnap.exists();
  }
  console.log("Creating new account with number:", newAccountNumber);
  await setDoc(doc(db, "users", newAccountNumber), { name });
  localStorage.setItem("accountNumber", newAccountNumber);
  localStorage.setItem("name", name);
  alert(`Your account number is: ${newAccountNumber}`);
  navigate("/home"); // Changed here as well
};


  return (
    <div className="login-container">
      <div className="login-form">
        <h2>Login</h2>
        <input
          type="text"
          placeholder="Enter Account Number"
          value={accountNumber}
          onChange={(e) => {
            setAccountNumber(e.target.value);
            setErrorMsg("");
          }}
          className="input-field"
        />
        <button onClick={handleLogin} className="btn">Login</button>
        {errorMsg && <p className="error-msg">{errorMsg}</p>}

        <div className="divider">OR</div>

        <h2>Create New Account</h2>
        <input
          type="text"
          placeholder="Enter Name"
          value={name}
          onChange={(e) => {
            setName(e.target.value);
            setErrorMsg("");
          }}
          className="input-field"
        />
        <button onClick={handleCreateAccount} className="btn">Create Account</button>
      </div>
    </div>
  );
};

export default LoginPage;
